<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p1y8Fu/tc-custom/9781612433431.jpg?1700957948236" alt="This image is the cover for the book Special Forces Fitness Training"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Special Forces Fitness Training
      </h1>
      <p class="bookDescription body article font2">
        <b>Reshape your body with the intense Navy SEAL and Army Ranger workout program created by a United States military strength and conditioning coordinator.</b><br/><br/> Do you have what it takes to be a special ops soldier? To be a member of the military’s most elite units—Navy SEALs, Marine Force Recon, Army Rangers or Green Berets—you must be in phenomenal condition, able to endure high levels of physical and mental stress. In this book, author Augusta DeJuan Hathaway shows how to get in the best shape of your life using the program he developed as a strength and conditioning specialist for the U.S. military special forces.<br/><br/> Be prepared to go all in or go home! <i>Special Forces Fitness Training</i> presents gym-free regimens that challenge you to train like a bad-ass. With the thirty hardcore workouts in this book you will:<br/><br/> • Develop massive strength<br/> • Increase speed &amp; agility<br/> • Extend fatigue threshold<br/> • Improve balance &amp; flexibility<br/> • Boost mental fortitude<br/>   
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Augusta DeJuan Hathaway
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e7298f98